<template>
  <div id="download">
    <!--openinstall的cdn链接-->
    <!-- <remote-js src="//res.cdn.openinstall.io/openinstall.js"></remote-js> -->

    <div class="relativeItem topimg">
      <img class="imgBlock noevents-img" src="../../assets/download/download(1).jpg" />
      <p class="absoluteItem">版本号:{{ version }}&nbsp;&nbsp;&nbsp;&nbsp;更新时间：{{ updateTime }}</p>
      <!--市场图-->
      <div class="imgs relativeItem" v-show="show_ul_img">
        <ul class="imgul">
          <li>
            <img class="imgBlock noevents-img" src="../../assets/download/download(2).png" />
          </li>
          <li>
            <img class="imgBlock noevents-img" src="../../assets/download/download(3).png" />
          </li>
          <li>
            <img class="imgBlock noevents-img" src="../../assets/download/download(4).png" />
          </li>
          <li>
            <img class="imgBlock noevents-img" src="../../assets/download/download(5).png" />
          </li>
        </ul>
      </div>
    </div>

    <!--按钮 -->
    <div class="an">
      <button
        id="downloadButton"
        class="radius05rem relativeItem flex-box ios"
        :class="{clicked:clicked}"
        v-if="device == 'ios'"
         @click="clickDown"
      >
        <img src="../../assets/download/ios.png" />
        <span>iPhone下载</span>
      </button>
      <button
        id="downloadButton"
        class="radius05rem relativeItem flex-box android"
        :class="{clicked:clicked}"
        v-else
         @click="clickDown"
      >
        <img src="../../assets/download/android.png" />
        <span>Android下载</span>
      </button>
    </div>
    <img class="imgBlock noevents-img textimg centerX" src="../../assets/download/download(1).png" />

    <!--弹窗-->
    <div class="tc" v-if="showTc" @click="showTc = false">
      <!--二维码-->
      <div class="qr centerImg" v-show="shwoQr">
        <img class="qrImg" :src="qr" style="width:40vw" @click.stop />
      </div>

      <!--确认按钮-->
      <div class="shell radius05rem centerImg" v-show="shwoShell">
        <img
          class="closeShell absoluteItem"
          src="../../assets/kefu (1).png"
          @click="showTc = false"
        />
        <a
          :href="downloadUrl"
          class="s1 radius05rem imgBlock"
          style="margin:10px auto 20px auto;border: 1px solid #df71e1;padding: 0.85rem 0;font-size: 15px;text-align: center;width:30vw;color:#df71e1;background:white"
        >立即下载</a>
        <a
          :href="url"
          class="s2 radius05rem imgBlock"
          style="margin:10px auto;border: 1px solid #df71e1;padding: 0.85rem 0;font-size: 15px;text-align: center;width:30vw;color:#fff;background:#df71e1"
        >前往应用宝</a>
      </div>
    </div>

    <!--外部浏览器打开提示-->
    <div class="tc" v-if="show_open_brower" @click="show_open_brower = false">
      <img src="../../assets/open_brower.png" />
    </div>
  </div>
</template>

<script>


export default {
  name: "download",
  components: {
    // "remote-js": {
    //   render(createElement) {
    //     return createElement("script", {
    //       attrs: { type: "text/javascript", src: this.src }
    //     });
    //   },
    //   props: {
    //     src: { type: String, required: true }
    //   }
    // }
  },
  data() {
    return {
      showTc: false, //是否显示弹窗
      shwoShell: false,
      shwoQr: false,
      show_open_brower: false,
      show_ul_img: false,
      qr: "", //二维码地址
      url: "", //应用宝下载地址
      downloadUrl: "", //本地下载地址
      clicked: false,
      device: "",
      version: "4.22",
      updateTime: "2020-4-17"
    };
  },
  methods: {
    /**计算滑动ul的宽度 */
    setWidth() {
      let _this = this;
      let ul = document.querySelector(".imgul");
      let li_width = document.body.clientWidth * 0.4;
      setTimeout(() => {
        ul.style.width = li_width * 4 + 28 + "px";
        _this.show_ul_img = true;
      }, 200);
    },

    /**点击下载按钮 */
    clickDown() {
      let _this = this;
      if (this.clicked) {
        return;
      } else {
        this.clicked = true;
      }
      setTimeout(() => {
        _this.clicked = false;
      }, 300);
      let ua = navigator.userAgent.toLowerCase(); //获取判断当前浏览器用的对象
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        if (this.device == "android") {
          //提示用户在外部浏览器打开
          this.show_open_brower = true;
        } else {
          window.location.href = this.url;
        }
      } else {
        window.location.href = this.url;
      }
    },

    /**请求下载资源 */
    getDown() {
      let _this = this;
      this.$jsonp(this.$apis("download", "app"), {}, res => {
        console.log(res)
        if (res.data.data.status == 200) {
          _this.device = res.data.data.device;
          if (
            res.data.data.device == "ios" ||
            res.data.data.device == "android"
          ) {
            _this.url = res.data.data.data;
          } else {
            _this.qr = res.data.data.data;
          }
        } else {
          _this.$tool.tip(res.data.data.msg);
        }
        //请求版本号
        _this.get_version();
      });
    },

    /**请求版本号 */
    get_version() {
      let _this = this;
      this.$jsonp(this.$apis("config", "app"), {}, res => {
        if (_this.device == "ios") {
          _this.version = res.data.data.result.list.ios_version;
          _this.updateTime = res.data.data.result.list.ios_uptime;
        } else {
          _this.version = res.data.data.result.list.android_version;
          _this.updateTime = res.data.data.result.list.android_uptime;
        }
      });
    },

    /**openinstall相关事务 */
    open_install_thing() {
      //openinstall初始化时将与openinstall服务器交互，应尽可能早的调用
      /*web页面向app传递的json数据(json string/js Object)，应用被拉起或是首次安装时，通过相应的android/ios api可以获取此数据*/
      // eslint-disable-next-line
      var data = OpenInstall.parseUrlParams(); //openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line
      new OpenInstall(
        {
          /*appKey必选参数，openinstall平台为每个应用分配的ID*/
          appKey: "tj3x4l",
          /*可选参数，自定义android平台的apk下载文件名；个别andriod浏览器下载时，中文文件名显示乱码，请慎用中文文件名！*/
          //apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',
          /*可选参数，是否优先考虑拉起app，以牺牲下载体验为代价*/
          //preferWakeup:true,
          /*自定义遮罩的html*/
          //mask:function(){
          //  return "<div id='openinstall_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
          //},
          /*openinstall初始化完成的回调函数，可选*/
          onready: function() {
            var m = this,
              button = document.getElementById("downloadButton");
            button.style.visibility = "none";
            /*在app已安装的情况尝试拉起app*/
            m.schemeWakeup();
            /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
            button.onclick = function() {
              m.wakeupOrInstall();
              return false;
            };
          }
        },
        data
      );
    }
  },
  mounted: function() {
    this.$tool.setTitle("APP下载");
    this.setWidth();
    this.getDown();
    // let _this = this;
    // setTimeout(() => {
    //   _this.open_install_thing();
    // }, 1000);
  }
};
</script>












<style scoped>
.topimg p {
  width: 100%;
  text-align: center;
  top: 34%;
  font-size: 12px;
  color: #999;
}

/**市场图 */
.imgs {
  width: 100vw;
  overflow-x: scroll;
}
.imgul {
  padding: 8px;
  overflow: hidden;
  z-index: 1;
}
.imgul li {
  width: 40vw;
  margin-right: 4px;
  float: left;
}
.imgul li:last-child {
  margin: 0;
}

/**按钮 */
.textimg {
  position: fixed;
  bottom: 9%;
  width: 100%;
  z-index: 1;
}
.an {
  position: fixed;
  z-index: 2;
  width: 100%;
  padding: 9px 0;
  background: white;
  bottom: 0;
  left: 0;
  border-top: 1px solid #f4f4f4;
}

.an button {
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  width: 165px;
  height: 50px;
  font-size: 15px;
  background: none;
  border-radius: 3rem;
}
.an .clicked {
  background: #f4f4f4;
}
.an img {
  width: 19px;
  margin-right: 9px;
}

.an .ios {
  border: 1px solid #000;
  color: #000;
}
.an .android {
  border: 1px solid #a1cc3d;
  color: #a1cc3d;
}

.qr {
  transform-origin: left top;
  animation: showDownload 0.2s;
  -webkit-animation: showDownload 0.2s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}

.shell {
  width: 75%;
  padding: 1.5rem 0;
  background: white;
  transform-origin: left top;
  animation: showDownload 0.2s;
  -webkit-animation: showDownload 0.2s;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}

.closeShell {
  width: 1.2rem;
  top: -1.5rem;
  right: 0;
}
</style>
